/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {FormEvent, MouseEvent} from 'react';

type TryCatchResult = {
    error?: Error;
    result?: unknown;
};

const PADDING = ['p-', 'pt-', 'pr-', 'pb-', 'pl-', 'px', 'py'];
const MARGIN = ['m-', 'mt-', 'mr-', 'mb-', 'ml-', 'mx', 'my'];

export const tryCatch = (fn: Function, ...args: any[]): TryCatchResult => {
    let error;
    let result;

    try {
        result = fn(...args);
    } catch (error_) {
        error = error_ as Error;
    }

    return {error, result};
};

export const noop = () => {};

export const noopPreventClick = (event: MouseEvent) => event.preventDefault();

export const noopPreventSubmit = (event: FormEvent) => event.preventDefault();

export const sleep = (ms: number) =>
    new Promise((resolve) => {
        setTimeout(resolve, ms);
    });

export const compose = (...fns: Function[]): Function =>
    fns.reduce(
        (f, g) =>
            (...args: unknown[]) =>
                f(g(...args)),
    );

export const hasPaddingClass = (className?: string) =>
    className ? PADDING.find((prefix) => className.includes(prefix)) : false;

export const hasMarginClass = (className?: string) =>
    className ? MARGIN.find((prefix) => className.includes(prefix)) : false;

/**
 * Helpers function that traverses up the parent chain and returns 'true' if the target or any parent nodes contain the specified data attrbute
 */
export const parentTreeHasDataAttribute = (
    target: HTMLElement,
    attribute: string,
): boolean => {
    if (target.hasAttribute(`data-${attribute}`)) {
        return true;
    }

    if (target.parentElement) {
        return parentTreeHasDataAttribute(target.parentElement, attribute);
    }

    return false;
};

/**
 * This function takes a string and returns a shortened version of it, with the specified length
 */
export const truncateLabel = (label: string) =>
    label.length > 16 ? `${label.slice(0, 12)}...${label.slice(-4)}` : label;

/**
 * This function takes a boolean to display or not the matching checkbox, enabled if true and disabled if false
 */
export const boolToIconString = (value: boolean) =>
    value ? 'enabled_checkbox' : 'disabled_checkbox';
